import state from './moduleOpportunityStatusState.js'
import mutations from './moduleOpportunityStatusMutations.js'
import actions from './moduleOpportunityStatusActions.js'
import getters from './moduleOpportunityStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
